import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import WinItLogoFaded from "../public/static/images/svg/WinItLogoFaded.svg"
import WinItLogoFadedCutBottomRight from "../public/static/images/svg/WinItLogoFadedCutBottomRight.svg"

const BackgroundImageLayerOne = styled.div`
  display: flex;
  height: 100%;
  flex-grow: 1;
  background-image: url(${WinItLogoFaded});
  background-repeat: no-repeat;
  background-position: ${props => props.miniLeft ? '-420px 0px' : '-420px 60px'};
  background-size: 660px 430px;
`

const BackgroundImageLayerTwo = styled.div`
  display: flex;
  height: 100%;
  flex-grow: 1;
  background-image: url(${WinItLogoFadedCutBottomRight});
  background-repeat: no-repeat;
  background-position: ${props => props.miniRight ? '100% 150%' : '100% 100%'};
`

const WinItBackgroundLogos = ({ children, miniRight, miniLeft }) => {
  return (
    <BackgroundImageLayerOne miniLeft={miniLeft}>
      <BackgroundImageLayerTwo miniRight={miniRight}>
        {children}
      </BackgroundImageLayerTwo>
    </BackgroundImageLayerOne>
  )
}

WinItBackgroundLogos.defaultProps = {
  miniLeft: false,
  miniRight: false,
}

WinItBackgroundLogos.propTypes = {
  miniLeft: PropTypes.bool,
  miniRight: PropTypes.bool
}

export default WinItBackgroundLogos
